module.exports = __webpack_public_path__ + "static/HKGrotesk-Regular-109c8fce3bd04beede2c6d46a47c389c.ttf";